import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { StickyBlockConfig } from '@front-platform/content-builder';
import { stickyBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface StickyBlockRuntimeConfig {
  'body'?: any;
}

export type StickyBlockConfigInput = Partial<
  Omit<StickyBlockConfig, keyof StickyBlockRuntimeConfig> & StickyBlockRuntimeConfig
>;
export type StickyBlockResolvedConfig = Omit<StickyBlockConfig, keyof StickyBlockRuntimeConfig> &
  Partial<StickyBlockRuntimeConfig>;
export interface StickyBlockContract extends ConfigComponentContract<
  StickyBlockConfigInput,
  StickyBlockResolvedConfig
> {}

@Component({
  selector: 'app-sticky-block',
  templateUrl: './sticky-block.component.html',
  styles: [],
  standalone: false,
})
export class StickyBlockComponent implements StickyBlockContract {
  readonly config = input<StickyBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<StickyBlockConfig, StickyBlockRuntimeConfig>(
    stickyBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }
  private _positionConfigOverride: string | undefined;
  get position(): string {
    return this._positionConfigOverride ?? (this.resolvedConfig()['position'] as unknown as string);
  }
  set position(value: string) {
    this._positionConfigOverride = value;
  }
  get gap(): string {
    return this.resolvedConfig()['gap'] as unknown as string;
  }

  getStyle() {
    return this.position === 'top'
      ? { top: this.gap + 'px' }
      : this.position === 'bottom'
        ? { bottom: this.gap + 'px' }
        : undefined;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(StickyBlockComponent, { 'keyAliases': {} });
